import {Grid, Typography} from '@material-ui/core';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import {urlPatterns} from 'core/urls';
import styles from './styles.css';

const PageTitle = props => {
    const splittedPathname = props.pathname.split('/').filter(v => v);
    const {title} = urlPatterns.filter(({path}) => {
        const splittedPath = path.split('/').filter(v => v);
        if (splittedPath.length > splittedPathname.length
            || splittedPath.length < splittedPathname.length
        ) return false;
        for (let index = 0; index < splittedPathname.length; index++) {
            const currentPath = splittedPathname[index];
            const otherPath = splittedPath[index];
            if (otherPath.includes(':') && /^-?\d+$/.test(currentPath)) {
                return true;
            } else if (currentPath !== otherPath) return false;
        }
        return true;
    })[0];

    return (
        <div className={classNames(styles.root, {[styles.rootHome]: title === 'Home'})}>
            <Grid container className={styles.titleContainer} alignItems='center'>
                <Grid item>
                    <Typography className={styles.pageTitle} variant='h1'>
                        {title !== 'Home' ? title : ''}
                    </Typography>
                </Grid>
            </Grid>
        </div>
    );
};

PageTitle.propTypes = {
    pathname: PropTypes.string,
};

export default PageTitle;



// WEBPACK FOOTER //
// ./components/page-title/index.js